import * as React from "react";
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import Typography from "@mui/material/Typography";
import reservationStore from "../../../store/reservationStore";
import { useEffect, useState } from "react";
import api from "../../../utils/api";
import * as util from "../../../utils/util";
import { d2024, d2025, d2026 } from "../../../utils/holidays";
import { PickersDay } from "@mui/x-date-pickers";
import Button from "@mui/material/Button";
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { Divider } from "@mui/material";
import Bottom from "../../Bottom";
import CircularProgress from "@mui/material/CircularProgress";

const hospitalParam = {
  cusId: '',
  famId: '',
  hosId: ''
}

const SetDate = (props: any) => {
  const storeData: any = reservationStore();
  const [allItems, setAllItems] = React.useState([]);
  const [capacity, setCapacity] = React.useState([{ classes: '', dateName: '', locdate: '', capacityClassItem: '', companyId: null, isCount: null, isOpen: null, reservationTime: 0 }]);
  const [packagesInfo, setPackagesInfo] = React.useState([]);
  const [disabledDays, setDisabledDays] = useState({ item: [{ locdate: '' }] }); // 선택 불가 일자
  const [iStartDate, setIStartDate] = useState(new Date());
  const [iEndDate, setIEndDate] = useState(new Date());
  const [endDateForFirst, setEndDateForFirst] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const [isSatOpen, setIsSatOpen] = React.useState(true);
  const [showCloseItems, setShowCloseItems] = React.useState(Boolean);
  const [selectedCapacity, setSelectedCapacity] = React.useState([{ classes: '', dateName: '', locdate: '', capacityClassItem: '', companyId: null, isCount: null, isOpen: null, reservationTime: 0 }]);
  const [isReady, setIsReady] = React.useState(false);

  // 초기 로딩 후에 컴포넌트 렌더링
  useEffect(() => {
    setTimeout(() => {
      setIsReady(true);
    }, 200); // 10ms 지연 후 렌더링 (최소한의 지연)
  }, []);
  
  useEffect(() => {
    // 필요한 api 호출을 위한 파라미터 세팅
    const companyInfo = JSON.parse((localStorage.getItem('companyInfo') || ''));
    hospitalParam.cusId = decodeURIComponent(localStorage.getItem("userCusID") || '');
    hospitalParam.famId = decodeURIComponent(storeData.reservationInfo.famId);
    hospitalParam.hosId = decodeURIComponent(storeData.reservationInfo.hosId);

    // 선택 병원의 capacity items
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/items/${new Date().getFullYear()}`).then(res => {
      setAllItems(res.data.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원의 capacity
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/capacity/capacities/${new Date().getFullYear()}`).then(res => {
      setCapacity(res.data.data.map((v: any) => {
        return {
          classes: v.classes,
          dateName: v.title,
          locdate: v.start.replaceAll(/[-]/ig, ""),
          capacityClassItem: v.capacityClassItem,
          companyId: v.companyId,
          isCount: v.isCount,
          isOpen: v.isOpen,
          reservationTime: v.reservationTime
        };
      }))
    }).catch(function (error) {
      console.log(error)
    });

    // 선택 병원과 접속 회원의 기업간의 제공되는 패키지
    api.get(`customer/api/v2/hospitals/${encodeURIComponent(hospitalParam.hosId)}/companies/${encodeURIComponent(companyInfo.company_id)}/packages`).then(res => {
      setPackagesInfo(res.data.data)
    }).catch(function (error) {
      console.log(error)
    });

    // 선택한 병원 정보
    api.post('customer/api/v1/CU_003_003_2', hospitalParam).then(res => {
      localStorage.setItem('HOS_INFO', JSON.stringify(res.data));
      setIsSatOpen(res.data['satOpen']);
    }).catch(function (error) {
      console.log(error)
    });

    // 휴일, 시작일, 종료일 disalbed 처리
    setDisabledDays(getRestDay(new Date().getFullYear()));
    setIStartDate(util.getBiggerDate(companyInfo.inspection_start, companyInfo.reservation_start));
    setIEndDate(util.getSmallerDate(companyInfo.inspection_end, companyInfo.reservation_end));
    const twoW = new Date().setDate(new Date().getDate() + 7);
    // setEndDateForFirst(new Date(companyInfo.cd));
    setEndDateForFirst(new Date(companyInfo.inspection_end));
    setStartDate(util.getBiggerDate(twoW, iStartDate));

    return () => {
      storeData.setReservationInfo('pkgId', '');
      storeData.setReservationInfo('addPrice', 0);
      storeData.setCheckedInjectioList([]);
      storeData.setChoiceLimitCount(0);
    }
  }, []);

  // 휴일 목록 제공 (기존에 API 호출 및 휴일 데이터 불러 왔었는데, API 호출 안되어서 휴일 데이터 제공 / 2024, 2025)
  function getRestDay(year: any) {
    let restDay: any = [];
    if (year === 2024) restDay = d2024;
    if (year === 2025) restDay = d2025;
    if (year === 2026) restDay = d2026;
    return restDay;
  }

  // 선택된 일자의 마감 정보(capacity) 가져오기
  function selectedReservationDate(selecteDate: any) {
    const selectedDate = dayjs(selecteDate.$d).format('YYYY-MM-DD');
    storeData.setReservationInfo('date', selectedDate);
    let FAM_INFO = JSON.parse(localStorage.getItem("FAM_INFO") || '');
    storeData.setReservationInfo('time', '');
    
    setSelectedCapacity(capacity.filter(d => d.locdate === dayjs(selecteDate.$d).format('YYYYMMDD')));

    storeData.setCloseItems([]);
    setShowCloseItems(false);
  }
  
  function selectedReservationTime(time: any){
    storeData.setReservationInfo('time', time);
  }

  const getMorningReservationTimes = (hospitalId : any) => {
    const defaultTimes = [1000, 1100];

    //예외
    if (hospitalId === 'HO#434') {
      return [900, ...defaultTimes];
    }

    return defaultTimes;
  };

  const getAfternoonReservationTimes = (hospitalId : any) => {
    const defaultTimes = [1300, 1400, 1500, 1600, 1700, 1800, 1900];

    //예외
    if (hospitalId === 'HO#434') {
      return [...defaultTimes, 2000];
    }

    return defaultTimes;
  };


  return (
    <Container sx={{ p: 0 }}>

      {/* <Stack direction='row' justifyContent={'center'} alignItems={'center'} sx={{ bgcolor: '#0d670320', mt: 1, p: 1, borderRadius: 3 }} >
        <ErrorOutlineOutlinedIcon sx={{ fontSize: '18px', color: '#777' }} /> 
        <Typography component={'div'} sx={{ fontSize: '16px', m: 1 }}>
          검진일은 현재 날짜 기준, <b> &nbsp;2주 후&nbsp; </b> 부터 선택이 가능합니다.
        </Typography>
      </Stack>
      */}
      <Stack direction={'row'} justifyContent={'center'} spacing={2}>
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko-KR">
          <Box sx={{width: '50%'}}>
            <DemoContainer components={['StaticDatePicker']} >
              <DemoItem>
                {isReady ? (
                  <StaticDatePicker
                    maxDate={dayjs(endDateForFirst)}
                    shouldDisableDate={
                      (date: any) => {
                        let disabled = false;
                        let targetDate = dayjs(date.$d).format('YYYYMMDD');
                        if (dayjs(startDate).format('YYYYMMDD') > targetDate) { // [1] 현재 날짜 기준, 2주는 disabled
                          disabled = false;
                        } else if (disabledDays.item.some(d => d.locdate == targetDate)) { // [1] 휴일 날짜들 disabled
                          disabled = !true;
                        } else if(date.$W === 0){ // 일요일 예약일자 close
                          disabled = false;
                          //예외추가
                          if (hospitalParam.hosId === 'HO#434') {
                            disabled = true;
                          }
                        } else if(date.$W === 6 && !isSatOpen) {  // !(토요일 && 병원 오픈) => 예약일자 close
                          disabled = isSatOpen
                        } else if (capacity.some(d => d.locdate == targetDate)) { // [1] 캐파 설정이 되어 있는 날짜들
                          const targetDateCapacity = capacity.filter(d => d.locdate === targetDate);
  
                          // 건강검진과 같이 isCount, isOpen 개념은 심리상담에서 없음
                          if(targetDateCapacity.some(c => c.classes === 'day-close')){
                            disabled = false;
                          }else if(targetDateCapacity.some(c => c.classes === 'time-close') || targetDateCapacity.some(c => c.classes === 'reserved-class')){
                            // 모든 시간대가 존재한다면 해당 일자 disabled
                            // 현재 시간대가 하드코딩되어 있으므로 8이라는 값도 하드코딩. 시간대 관리되면 그걸 토대로 조회 값으로 변경 필요
                            disabled = capacity.filter(d => d.locdate === targetDate).length !== 8;
                          }
                        } else {  
                          /* 
                            아래 경우 제외 하고 예약일자 오픈
                            1. 휴일
                            2. 일요일
                            3. 토요일 open 아닌 경우
                            4. 토요일 open인데 캐파 있는 경우 (캐파 확인 후 결정)
                          */
                          if (date.$W !== 0) disabled = true;  // 예약일자 open
                        }
                        
                        return !disabled;
                      }
                    }
                    onChange={(newValue) => selectedReservationDate(newValue)}
                    sx={{
                      width: '100%', borderRadius: '12px 12px 0px 0px',
                      '& .MuiDateCalendar-root': { p: 2 },
                      '.MuiPickersToolbar-content': {
                        backgroundColor: '#f1f1f1',
                        p: '10px 0',
                        justifyContent: 'center', borderRadius: 3
                      },
                      '.MuiPickersToolbar-content .MuiDatePickerToolbar-title': {
                        fontSize: 18,
                        color: '#333',
                        fontWeight: 700
                      },
                      '.MuiPickersToolbar-content .MuiDatePickerToolbar-title:before': {
                        content: '"예약일은 "',
                        fontWeight: 500
                      },
                      '.MuiPickersToolbar-content .MuiDatePickerToolbar-title:after': {
                        content: '" 입니다 "',
                        fontWeight: 500
                      },
                      '.MuiTypography-overline': {
                        display: 'none'
                      },
                      '.MuiDialogActions-root ': {
                        display: 'none'
                      },
                      '.MuiDayCalendar-weekDayLabel': {
                        width: '40px',
                        height: '40px',
                        fontSize: 16
                      },
                      '.MuiPickersDay-root': {
                        width: '40px',
                        height: '40px',
                        fontSize: 16,
                        bgcolor: '#00bc1417',
                        fontWeight: 700
                      },
                      '.MuiPickersDay-root.Mui-disabled:not(.Mui-selected)': {
                        bgcolor: '#ffa0a014',
                      }
                    }}
                    slotProps={{
                      toolbar: {
                        toolbarFormat: 'MM월 DD일',
                      },
                      calendarHeader: { format: 'YYYY년 MM월' }
                    }}              
                  />
                ) : (
                  <Box sx={{ display: !isReady ? 'flex' : 'none', textAlign: 'center'}} justifyContent='center' alignContent={'center'}>
                    <CircularProgress />
                  </Box>
                )}
              </DemoItem>
              
            </DemoContainer>

            <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} sx={{ bgcolor: '#fff', borderTop: '1px solid #eee', p: 2 }}>
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#ff9d9d6e', mr: 1 }}></Box>
                <Typography sx={{ fontSize: 16 }}>예약마감</Typography>
              </Stack>
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#00bc143d', mr: 1 }}></Box>
                <Typography sx={{ fontSize: 16 }}>예약가능</Typography>
              </Stack>
            </Stack>
          </Box>

        </LocalizationProvider>
      
        <Stack sx={{width: '45%', background: '#fff', marginTop: '8px !important', borderRadius: '12px 12px 0px 0px'}}>
          
          <Box sx={{p: '16px 24px'}}>
            <Typography variant="h4"
              sx={{
                fontSize: '18px', fontWeight: 500, color: '#333', backgroundColor: '#f1f1f1', p: '10px 0 !important', borderRadius: '12px', textAlign: 'center',
                "&:before": {
                  content: '"예약시간은"',
                },
                "&:after": {
                  content: '"입니다"',
                }
              }}>
              &nbsp;{storeData.reservationInfo.time == null || storeData.reservationInfo.time === '' || storeData.reservationInfo.time === undefined
                ? '-' : ` ${String(storeData.reservationInfo.time).slice(0, -2)}:${String(storeData.reservationInfo.time).slice(-2)}`}
              &nbsp;
            </Typography>
          </Box>
          <Stack sx={{height: '100%', p: '0px 25px'}}>
            <Box sx={{borderBottom: '1px solid #eee', p: 2}}>
              <Stack direction={'row'} alignItems={'center'}>
                <Typography sx={{minWidth : '100px'}}>오전</Typography>
                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'}
                  sx={{
                    marginLeft: '20px', gap: 2,
                    '& Button' : {backgroundColor: ' #00bc143d !important', border: '1px solid #fff', borderRadius: '50px', color: '#333'},
                    '& Button:hover' : {border: '1px solid #0d670399'}
                  }}>
                  {getMorningReservationTimes(hospitalParam.hosId).map((time, index) => (
                    <Button variant="outlined" disabled = {selectedCapacity.some(c => c.reservationTime == time)} onClick={() => selectedReservationTime(time)}>
                      {String(time).slice(0, -2)}:{String(time).slice(-2)}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </Box>
            <Box sx={{p: 2}}>
              <Stack direction={'row'} alignItems={'center'}>
                <Typography sx={{minWidth : '100px'}}>오후</Typography>
                <Stack direction={'row'} alignItems={'flex-start'} flexWrap={'wrap'}
                  sx={{
                    marginLeft: '20px', gap: 2,
                    '& Button' : {backgroundColor: ' #00bc143d !important', border: '1px solid #fff', borderRadius: '50px', color: '#333'},
                    '& Button:hover' : {border: '1px solid #0d670399'}
                  }}>
                  {getAfternoonReservationTimes(hospitalParam.hosId).map((time, index) => (
                    <Button variant="outlined" disabled = {selectedCapacity.some(c => c.reservationTime == time)} onClick={() => selectedReservationTime(time)}>
                      {String(time).slice(0, -2)}:{String(time).slice(-2)}
                    </Button>
                  ))}
                </Stack>
              </Stack>
            </Box>
          </Stack>
          <Stack direction={'row'} justifyContent={'center'} alignItems={'center'} spacing={2} sx={{ bgcolor: '#fff', borderTop: '1px solid #eee', p: 2 }}>
              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#ff9d9d6e', mr: 1 }}></Box>
                <Typography sx={{ fontSize: 16 }}>예약마감</Typography>
              </Stack>

              <Stack direction={'row'} justifyContent={'center'} alignItems={'center'}>
                <Box sx={{ width: 15, height: 15, borderRadius: 7, bgcolor: '#00bc143d', mr: 1 }}></Box>
                <Typography sx={{ fontSize: 16 }}>예약가능</Typography>
              </Stack>
            </Stack>
        </Stack>
      </Stack>
      <Box sx={{ bgcolor: '#FFFBF8', pb: 1, display: showCloseItems ? 'block' : 'none', flexDirection: 'column' }} >
        <Box sx={{ width: '100%' }}>
          <Typography sx={{ display: 'flex', fontSize: '16', m: 0, alignItems: 'center', justifyContent: 'center', bgcolor: '#ff6161', color: '#fff', fontWeight: 700, p: 1 }}>
            <ErrorRoundedIcon sx={{ mr: 1, color: '#fff' }} /> 일부 마감 항목

          </Typography>
        </Box>
        <Box sx={{ width: '100%' }}>
          {storeData.closeItems.map((ci: any, index: any) => (
            <Typography key={ci.uid} sx={{ display: 'flex', fontSize: '14px', m: 1, alignItems: 'center', justifyContent: 'center', }}>
              <ErrorOutlineOutlinedIcon sx={{ mr: 1, color: '#ff6161' }} />  {ci.item.name}
            </Typography>
          ))}
        </Box>
      </Box>
    </Container>
  );
}

export default SetDate;